define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function FileReaderError(stack, source) {
        UploadFail.apply(this, arguments);
    }

    FileReaderError.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: FileReaderError,
        className: 'FileReaderError',
        radarName: 'filereader_fail',
        message: 'Не удалось прочитать файл.',
    });

    module.exports = FileReaderError;
});
